import { useFormContext, useWatch } from 'react-hook-form';

import { Grid, Typography } from '@mui/material';

import { NumericFormatInputController } from 'controllers/numeric-format-input-controller';
import { SwitchController } from 'controllers/switch-controller';

import { IUser } from 'utils/types';

import { storageDetailsStyles } from './styles';

interface IProps {
  user: IUser;
}

const formatPlanStorageLimit = (planStorageLimitGb: number | null | undefined) => {
  if (typeof planStorageLimitGb === 'number') {
    return `${planStorageLimitGb} GB`;
  }

  return 'Unlimited';
};

export const StorageDetails = ({ user }: IProps) => {
  const { control } = useFormContext();

  const hasStorageLimitOverride = useWatch({
    control,
    name: 'hasStorageLimitOverride',
  });

  return (
    <Grid sx={storageDetailsStyles.container}>
      <Typography sx={storageDetailsStyles.planLimitHint}>
        Plan storage limit: {formatPlanStorageLimit(user.planStorageLimitGb)}
      </Typography>

      <Grid sx={storageDetailsStyles.overrideContainer}>
        <Typography sx={storageDetailsStyles.itemTitle}>Storage Limit</Typography>

        <Grid sx={storageDetailsStyles.switchContainer}>
          <Typography sx={storageDetailsStyles.itemLabel}>Override</Typography>
          <SwitchController name="hasStorageLimitOverride" />
        </Grid>

        {hasStorageLimitOverride && (
          <NumericFormatInputController
            withError
            allowNegative={false}
            fullWidth
            type="tel"
            label="Storage Amount (GB)"
            name="storageLimitOverride"
            placeholder="Leave empty for unlimited"
          />
        )}
      </Grid>
    </Grid>
  );
};
